<template>
  <div>
    <tableScreen :queryForm="queryForm" @query="queryBySearch"></tableScreen>
    <el-table
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      height='calc(100vh - 235px)'>
      <el-table-column
        width="150" fixed="left"  label="申请编号">
        <template slot-scope="scope">
          <span v-if="scope.row.outlayType == '2' && scope.row.applyType == 1">{{scope.row.specialPatientId}}</span>
          <span v-else>{{scope.row.helpId}}</span>
        </template>
      </el-table-column>
      <el-table-column width="100"  label="申请时间" fixed="left">
        <template v-slot="scope">
          <span v-if="scope.row.submitTime">
            {{scope.row.isSpecialPatient == 1 ? parseTime(scope.row.submitTime, '{y}-{m}-{d}') : parseTime(scope.row.submitTime, '{y}-{m}-{d}')}}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="childName" width="110" label="患儿姓名" fixed="left">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName">
            <span class="link" @click="toDetail(scope.row)">{{scope.row.childName}}</span>
          </TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="reqModeText" width="80"  label="申请方式">
      </el-table-column>
      <el-table-column      v-if="isHospital==='false'"   width="140"   label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="diseasesNameSet"  min-width="200" label="病种">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="isSpecialPatient" width="50" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.applyType == 2">补款</span>
          <span v-else-if="scope.row.applyType == 3">退款</span>
          <span v-else>{{scope.row.isSpecialPatient==1 ? '特患' : '普通' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  width="120" prop="initialProjectName" label="所属项目">
      </el-table-column> -->
      <el-table-column prop="type"  width="70" label="期次">
        <template slot-scope="scope">
          {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-')) }}
        </template>
      </el-table-column>
      <el-table-column  width="120" label="出生日期">
        <template v-slot="scope">
          {{scope.row.birthday | convertTime('YYYY-MM-DD')}}
        </template>
      </el-table-column>
      <el-table-column prop="sexText" width="50"  label="性别">
      </el-table-column>
      <el-table-column width="120"  label="户口所在地">
        <template slot-scope="scope">
          <TableCellWordBreak :content="(scope.row.provinceText || '') + (scope.row.cityText || '')"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column width="100"  prop="helpStatusText" label="救助状态">
        <template slot-scope="scope">
          <span v-if="scope.row.apprStatus == 5">审核中</span>
          <span v-else :class="scope.row.apprStatus == 3 ? 'warning-text' : ''">{{scope.row.apprStatusText || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column width="100"  label="审核时间">
        <template slot-scope="scope">
          <span v-if="scope.row.apprStatus == 5">-</span>
          <span v-else-if="scope.row.apprTime">{{scope.row.apprTime | convertTime('YYYY-MM-DD')}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="outlayStatusText" width="110"  label="金额" align="right">
        <template slot-scope="scope">
          {{ scope.row.helpAmount ? parseFloat(scope.row.helpAmount).toFixed(2) : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="outlayStatusText" width="80"  label="费用状态">
        <template slot-scope="scope">
          {{ scope.row.applyType == 1 && scope.row.outlayStatusText ? scope.row.outlayStatusText : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="protocolId" width="130"  label="协议编号">
        <template slot-scope="scope">
          <TableCellWordBreak v-if="scope.row.protocolId && (scope.row.publishStatus == 2 || scope.row.applyType != 2)" :content="scope.row.protocolId">
            <span class="link" @click="openAgreeDialog(scope.row)">{{scope.row.protocolId}}</span>
          </TableCellWordBreak>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="protocolStatusText" width="80"  label="协议状态">
        <template slot-scope="scope">
          <span v-if="scope.row.applyType == 2 && scope.row.publishStatus != 2">待生成</span>
          <span v-else>{{scope.row.protocolStatusText || '-'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pageination @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :currentPage="queryForm.pageNO"
      :total="total">
    </Pageination>

    <ProtocolDetailDialog :dialogVisible.sync="agreeDialog" v-if="agreeDialog" :protocolId="proId"></ProtocolDetailDialog>
    <HelpDetailDialog
      v-if="detailJzDialog"
      :visible="detailJzDialog"
      :belongProject="chooseData.initialProject"
      :outlayId="outlayId"
      :helpId="chooseHelpId"
      :helpData="chooseData"
      @close="detailJzDialog = false">
    </HelpDetailDialog>
  </div>
</template>

<script>
  import { getDataListByCondFq, getMyOutlayListByCond } from "@/util/api";
  import Pageination from "@/components/business/Pageination";
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import tableScreen from "./tableScreen";

  import HelpDetailDialog from '../view/HelpDetailDialog';
  import ProtocolDetailDialog from '../view/ProtocolDetailDialog';

  import moment from "moment";
  export default {
    components: {
      HelpDetailDialog,
      ProtocolDetailDialog,
      TableCellWordBreak,
      tableScreen,
      Pageination
    },
    data() {
      return {
        proId: '',
        agreeDialog: false,
        detailJzDialog: false,
        detailTxDialog: false,
        detailTsDialog: false,
        showTabel:false,
        chooseData: {},
        chooseHelpId: '',
        isHospital:'false',
        outlayId: '',
        queryForm: {
          "searchCond": {
            "reqMode":'',
            "childName": "", //患儿姓名
            "diseasesId": "", //病种
            "hospitalId": "", //救助医院
            "idNumber": "", //身份证号
            "province": "", //所在省
            "city": "", //所在市
            "county": "", //所在区县
            "requestTimeBegin": "", //申请时间（开始）
            "requestTimeEnd": "", //申请时间（结束）
            "apprStatus": "", //救助状态
            "apprTimeBegin": "", //审核时间（开始）
            "apprTimeEnd": "", //审核时间（结束）
            "outlayStatus": "", //费用状态
            "protocolStatus": "", //协议状态
            "isTimeout": "", //是否超期患儿
            "specialFlag": "", //特殊标记（1=公益宝贝，2=三区三州）
            "isSpecialPatient": "", //是否特患
          },
          "orderBy": "createAt desc",
          "pageNO": 1,
          "pageSize": 10
        },
        breadConf: {
          name: '患儿管理',
          icon: '/static/m-childm.png',
        },
        total: 0,
        value1: '',
        value2: '',
        tableData: [],
        loading: false
      }
    },
    created() {
      this.isHospital = window.localStorage.getItem("hospAccount")
      if(this.$route.query.status){
        this.queryForm.searchCond.apprStatus = this.$route.query.status
      }
      if(this.$route.query.needPostoperaPhoto){
        this.queryForm.searchCond.needPostoperaPhoto = this.$route.query.needPostoperaPhoto
      }
      if(this.$route.query.mode){
        this.queryForm.searchCond.reqMode = parseInt(this.$route.query.mode)
        this.$forceUpdate()
      }

      this.queryList()
      // isHospital
      // window.localStorage.getItem("hospAccount")

    },
    watch: {
      '$route.query.q' : {
        deep: true,
        handler () {
          this.queryList();
        }
      }
    },
    methods: {
      requsetDetail(obj) {
        this.chooseHelpId = obj.helpId
        this.outlayId = obj.outlayId
        this.chooseData = obj
        this.detailJzDialog = true
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      openAgreeDialog(obj) {
        this.proId = obj.protocolId
        if (obj.applyType == 1) {
          this.$router.push({
            path: '/protocol/detail/' + obj.protocolId
          })
        } else {
          this.$router.push('/child/refund/' + obj.protocolId + '/' + obj.applyType + '/' + obj.applyId + '/y');
        }
      },
      //分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.queryForm.pageSize = val
        this.queryList()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.queryForm.pageNO = val
        this.queryList()
      },
      openScreenFun() {
        this.openScreen1 = !this.openScreen1
      },
      toDetail(obj) {
        this.$router.push({
          path: '/child/detail',
          query: {
            'uid': obj.childUid,
            'helpId': obj.helpId
          }
        })
      },
      formatDate(row, colum) {
        var date = row[colum.property]
        if (date === undefined) {
          return '-'
        }
        return moment(date).format('YYYY-MM-DD')
      },
      queryBySearch(form) {
        this.queryForm = form
        this.queryList()
      },
      queryList() {

        let param = this.queryForm;
        for (var key in param.searchCond) {
          if (!param.searchCond[key]) {
            delete param.searchCond[key]
          }
        }
        // this.queryForm.searchCond.isSubmit =1
        this.loading = true

        param.searchCond.forNotDraft = 1;
        getMyOutlayListByCond({
          ...param,
          searchCond: {
            ...param.searchCond,
            publishStatus: 2,
            apprStatus: param.searchCond.apprStatus == 1 ? '1,5' : param.searchCond.apprStatus
          }
        }).then(res => {
          this.tableData = res.responseData.modelData
          this.total = res.responseData.total
          this.loading = false
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/child/manage/ChildManage.vue